module.exports = __webpack_public_path__ + "media/images/payments/monero-0d03a94f0bb3fbb8bafe4ef22ae1f8ab.svg";